var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultSelect',{class:_vm.componentClass,attrs:{"title":_vm.title,"options":_vm.roleSelectOptions,"selectedItem":_vm.value,"onChange":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }